import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-typewriter-text',
  templateUrl: './typewriter-text.component.html',
  styleUrl: './typewriter-text.component.scss'
})
export class TypewriterTextComponent implements OnInit, OnDestroy {
  displayedText = '';
  private textIndex = 0;
  private charIndex = 0;
  private typingInterval: any;
  private cycleTimeout: any;
  @Input({required:true}) texts:string[];

  ngOnInit(): void {
    this.startTypingCycle();
  }

  startTypingCycle() {
    const typeNextChar = () => {
      const currentText = this.texts[this.textIndex];

      if (this.charIndex < currentText.length) {
        this.displayedText += currentText[this.charIndex];
        this.charIndex++;
      } else {
        clearInterval(this.typingInterval);

        // Wait 10 seconds then clear and type next
        this.cycleTimeout = setTimeout(() => {
          this.displayedText = '';
          this.charIndex = 0;
          this.textIndex = (this.textIndex + 1) % this.texts.length;
          this.typingInterval = setInterval(typeNextChar, 100);
        }, 5000);
      }
    };

    this.typingInterval = setInterval(typeNextChar, 100);
  }

  ngOnDestroy(): void {
    clearInterval(this.typingInterval);
    clearTimeout(this.cycleTimeout);
  }
}
